import React from 'react';
import { FormattedMessage } from 'react-intl';
import randomstring from 'uuid/v4';

import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Check from '@material-ui/icons/CheckCircle';

function isOk(percentage, hour, to) {
    return !!percentage && !!hour && !!to;
}

class ModifyRanges extends React.Component {
    state = {
        percentage: '',
        hours: this.props.hours ? this.props.hours : [],
        hour: undefined,
        to: '',
    };

    static getDerivedStateFromProps(props, state) {
        if (props.hours && props.hours !== state.hours) {
            state.hours = props.hours;
            return state;
        }
        return null;
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleClick = (event) => {
        const { percentage, hour, to } = this.state;
        if (isOk(percentage, hour, to)) {
            this.props.onUpdate(percentage, hour, to);
            this.setState({ percentage: '', hour: undefined, to: '' });
        }
    };

    render() {
        const { percentage, hours, hour, to } = this.state;
        return (
            <div
                className={
                    'flex_full_row center barlow_regular_small nowrap padding_bottom_24 c_cool_grey'
                }
            >
                <FormattedMessage id={'forecast_modidy'} />
                <TextField
                    id={'percentage'}
                    name={'percentage'}
                    required
                    className={'flex_full_row'}
                    classes={{
                        root: 'production_total_card_input padding_left_12 padding_right_12',
                    }}
                    value={percentage}
                    onChange={this.handleChange}
                    margin="normal"
                    type="number"
                    InputProps={{
                        pattern: '[0-9]*',
                        classes: {
                            input: 'c_dark_grey_blue barlow_medium text_align_right',
                        },
                    }}
                />
                <FormattedMessage id={'forecast_percentage'} />
                <FormControl
                    className={
                        'flex_full width100 barlow_italic c_slate  padding_left_12 padding_right_12'
                    }
                >
                    <Select
                        native
                        value={hour}
                        onChange={this.handleChange}
                        inputProps={{ name: 'hour', id: 'hour-id' }}
                    >
                        <option key={randomstring()} value={undefined} />
                        {hours &&
                            hours.map((cat) => {
                                return (
                                    <option key={randomstring()} value={cat.id} disabled={cat.disabled}>
                                        {cat.name}
                                    </option>
                                );
                            })}
                    </Select>
                </FormControl>
                <FormattedMessage id={'forecast_period'} />
                <FormControl
                    className={
                        'flex_full width100 barlow_italic c_slate  padding_left_12 padding_right_12'
                    }
                >
                    <Select
                        native
                        value={to}
                        disabled={!hour}
                        onChange={this.handleChange}
                        inputProps={{ name: 'to', id: 'to-id' }}
                    >
                        <option key={randomstring()} value={undefined} />
                        {hours &&
                            hours.map((cat) => {
                                return (
                                    <option key={randomstring()} value={cat.id} disabled={cat.disabled || cat.id < hour}>
                                        {cat.name}
                                    </option>
                                );
                            })}
                    </Select>
                </FormControl>
                <Check
                    fontSize="large"
                    className={
                        'hand padding_left_12 barlow_regular ' +
                        (isOk(percentage, hour, to) ? 'c_pea' : 'c_cool_grey_two')
                    }
                    onClick={this.handleClick}
                />
            </div>
        );
    }
}

export default ModifyRanges;



// WEBPACK FOOTER //
// ./src/components/complex/inventory/forecast/ModifyRange.js